import React from "react";
import { Link } from "react-router-dom";
import skillsData from "./SkillsData";
import SkillCard from "./Skillcard";
import animeMyself from "../assets/animeMyself.png";

const Skills: React.FC = () => {
    return(
        <div className="relative min-h-screen overflow-hidden selection:bg-fuchsia-900">
            <Link to="/">
            <img 
                src={animeMyself}
                alt="A personal anime version profile selfie and clickable to return"
                className="max-w-40 max-h-20"
            />
            </Link>
            { /* Mobile Design below */ }
                <div className="relative min-h-screen overflow-hidden lg:hidden">
                          <div className="relative block lg:hidden px-5 py-3">
                            <div className="mx-auto max-w-md">
                            <div className="mb-10 text-center">
                                <h1 className="text-4xl font-bold tracking-tight">My Skills</h1>
                                <p className="mt-4">
                                    A snapshot of my technical expertise, tools, and technologies.
                                </p>
                            </div>

                            <div className="space-y-5">
                                {skillsData.map((category) => (
                                <SkillCard key={category.title} category={category} mobile />
                                ))}
                            </div>
                            </div>
                        </div>
                </div>
            { /* Desktop Design below */ }
                <div className="relative hidden lg:flex lg:min-h-screen lg:flex-col lg:items-center">
                    <div className="w-full max-w-7xl">
                        <div className="mb-5 text-center">
                            <h1 className="text-6xl font-bold tracking-tight">My Skills</h1>
                            <p className="mt-5 text-2xl">
                                A snapshot of my technical expertise, tools, and technologies.
                            </p>
                        </div>
                        <div className="grid grid-cols-3 gap-6 py-2">
                            {skillsData
                            .map((category) => (
                                <SkillCard key={category.title} category={category} />
                            ))}
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default Skills;
